document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('slideshow-component');

  sliders.forEach(slider => {
    // Kill autoplay if any
    if (slider.autoplayInterval) {
      clearInterval(slider.autoplayInterval);
    }

    // Remove autoplay attribute
    slider.removeAttribute('data-autoplay');

    // Stop auto movement on focus / scroll
    slider.style.scrollBehavior = 'auto';
  });
});
